import React, { useRef, useState } from 'react';
import LoginForm from '../LoginForm/LoginForm';

const LoginPage = ({ data }) => {
    return <div className="flex justify-center items-center min-h-screen bg-gray-50 p-6">
        <div className="w-full max-w-sm bg-white shadow-md rounded-lg p-6">
            <LoginForm returnUrl={data.ReturnUrl} />
        </div>
    </div>
}
export default LoginPage;